import { render, staticRenderFns } from "./badgesList.vue?vue&type=template&id=1e3f55e8&scoped=true&"
import script from "./badgesList.vue?vue&type=script&lang=js&"
export * from "./badgesList.vue?vue&type=script&lang=js&"
import style0 from "./badgesList.vue?vue&type=style&index=0&id=1e3f55e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f55e8",
  null
  
)

export default component.exports